<template>
	<div>
		<h1>Debi/Kredi - Dokumente transferieren</h1>
		<button @click="$router.push({ path: '/home/arap'})"><i class="fas fa-chevron-left rmargin"></i> Zurück zur OP-Liste</button>
		<button @click="start_transfer()" :disabled="hndlEvent !== 0"><i class="fas fa-play-circle rmargin"></i> Transfer starten</button>

		<div v-if="$store.state.customer.accounting_tool === 'pesaris 2'" class="reftype">
			<label for="reftype">Belegart</label>
			<select v-model="reftype" id="reftype">
				<option v-for="(rec,idx) in reftypes" :key="idx" :value="rec.id">{{ rec.label }} ({{ rec.description }})</option>
			</select>
		</div>
		
		<br>
		
		<table>
			<thead>
				<th></th>
				<th>Datum</th>
				<th>Pers.kto.nr.</th>
				<th>Personenkonto</th>
				<th>Bezeichnung</th>
				<th>Typ</th>
				<th>Beleg Nr.</th>
				<th>Whr</th>
				<th>Betrag</th>
				<th>Soll</th>
				<th>Haben</th>
				<th>Status</th>
				
				<th></th>
			</thead>
			<tbody>

				<tr v-for="(rec,idx) in recs" :key="rec.id">
					<td><input type="checkbox" v-model="rec.selected"></td>
					<td>{{ rec.date | recdate }}</td>
					<td><input type="text" v-model="rec.pa_number" class="stxt"></td>
					<td>{{ rec.pa_name }}</td>
					<td>{{ rec.name }}</td>
					<td><span class="badge" :class="rec.type">{{ rec.type === 'ar' ? 'DEBI' : 'KREDI' }}</span></td>
					<td><input type="text" v-model="rec.refnum" class="stxt"></td>
					<td>{{ rec.ccy }}</td>
					<td>{{ rec.amount }}</td>
					<td>{{ rec.debit_acct }}</td>
					<td>{{ rec.credit_acct }}</td>
					<td><span class="badge" :class="rec.status" :title="rec.hasOwnProperty('error') ? rec.error : null">{{ status_label(rec.status) }}</span></td>
					<td><a :href="$globals.API_REL_URL + 'arappdf.php?c=' + client_id + '&f=' + rec.doc_checksum" target="_blank" class="anl"><i class="far fa-file-pdf" title="PDF öffnen"></i></a></td>
				</tr>
			</tbody>
		</table>

		<button @click="select_all()"><i class="far fa-check-square rmargin"></i> Alles auswählen</button>
		<button @click="select_none()"><i class="far fa-square rmargin"></i> Auswahl aufheben</button>
		
		<modal name="modalSubmit" width="350" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">Übermittlung bestätigen</div>
			<div class="delConf-content">
				'{{ selected_name }}' wirklich übermitteln?
			</div>
			<div class="delConf-button-wrapper">
				<button @click="submitImportData" class="delConf-btn-del">Ja</button>
				<button @click="$modal.hide('modalSubmit')">Nein</button>
			</div>
		</modal>
		
		<vue-snotify></vue-snotify>
		<iframe :src="download.src" style="position: absolute;width:0;height:0;border:0;"></iframe>
	</div>
</template>

<script>
  import ApiComm from '../../apicomm.js'
  import axios from 'axios'
  
  export default {
    components: {},
    mixins: [ApiComm],
	data() {
		return {
			selected_id: '',
			selected_name: '',
			reftype: '',
			reftypes: [],
			recs: [],
			hndlEvent: 0,
			filter: {
				date: {
					mode: '',
					start: '',
					end: '',
				},
				type: '',
				status: '',
				text: ''
			},
			download: {
				filename_format: '',
				src: ''
			}
		}
	},
    computed: {
		client_id () {
			return this.$store.state.customer.id
		},
		
		valid_start_date () {
			if (/^[0-3]?[0-9]{1}\.[01]?[0-9]{1}\.(19|20)[0-9]{2}$/.test(this.filter.date.start) === false) return false;
			var d = this.$moment(this.filter.date.start, 'DD.MM.YYYY');
//console.log(this.filter.date.start + ' -> ' + (d.isValid() ? 'TRUE -> ' + d.format('YYYY-MM-DD') : 'FALSE'));
			return d.isValid();
		},
		
		valid_end_date () {
			if (/^[0-3]?[0-9]{1}\.[01]?[0-9]{1}\.(19|20)[0-9]{2}$/.test(this.filter.date.end) === false) return false;
			var d = this.$moment(this.filter.date.end, 'DD.MM.YYYY');
			return d.isValid();
		}
	},
    methods: {
		start_transfer() {
			var vm = this, i, o = vm.$_.cloneDeep(vm.recs), n = o.length, has_selections = false, p, accounting_tool = vm.$store.state.customer.accounting_tool;
			for (i=0; i<n; i++) {
				if (o[i].selected) {
					has_selections = true;
					break;
				}
			}
			
			if (!has_selections) {
				vm.$snotify.error('Kein Dokument ausgewählt!', 'ERROR', {timeout: 8000})
				return;
			}
			
			if (accounting_tool === 'pesaris 2' && vm.reftype === '') {
				vm.$snotify.error('Keine Belegart ausgewählt!', 'ERROR', {timeout: 8000})
				return;
			}

			p = o.filter(x => x.selected && (x.status === 'ready' || x.status === 'pending' || x.status === 'error'));
			
			//Nicht benötigte Daten löschen, damit Übermittlung etwas "schlanker" wird
			n = p.length;
			if (n === 0) return; //Wenn Array leer ist, dann Übermittlung hier abbrechen
			for (i=0; i<n; i++) {
				Object.keys(p[i]).forEach((key) => ['id','pa_number','reftype','refnum'].includes(key) || delete p[i][key]);
				
				if (accounting_tool === 'pesaris 2') p[i]['reftype'] = vm.reftype;
			}
			
			vm.hndlEvent = new EventSource(vm.$globals.API_REL_URL + "araptransfer_evt.php?cid=" + vm.client_id + "&p=" + encodeURIComponent(JSON.stringify(p)));

			vm.hndlEvent.addEventListener('update', function(event) {
				//Wird ausgelöst wenn Stammdaten aktualisiert wurden (INSERT oder UPDATE)
				vm.data_update_handler(JSON.parse(event.data));
			});

			vm.hndlEvent.addEventListener('close', function(event) {
				vm.hndlEvent.close();
				vm.hndlEvent = 0;
				//Meldung in event.data dem User anzeigen -> nur wenn JSON.parse(event.data).msg !== 'normal'
				i = JSON.parse(event.data);
				if (i.msg !== 'normal') vm.$snotify.error(i.msg, 'ERROR', {timeout: 8000})
			});
		},
		
		data_update_handler(data) {
//			console.log('data_update_handler -> ' + JSON.stringify(data));
			var idx = this.recs.findIndex(x => x.id === data.id);
			if (idx !== -1) {
				if (data.hasOwnProperty('error')) {
					this.recs[idx].status = 'error';
					this.recs[idx]['error'] = data.error.msg;
				} else {
					this.recs[idx].status = 'submitted';
					this.recs[idx].reftype = data.reftype;
					this.recs[idx].refnum = data.refnum;
					if (this.recs[idx].hasOwnProperty('error')) delete this.recs[idx].error;
					
					this.recs.push({});
					this.recs.pop();
				}
			}
		},
		
		select_all() {
			var i, o = this.recs, n = o.length;
			for (i=0; i<n; i++) o[i].selected = true;
		},
		
		select_none() {
			var i, o = this.recs, n = o.length;
			for (i=0; i<n; i++) o[i].selected = false;
		},
		
		status_label(status) {
			switch (status) {
				case 'pending': return 'in Arbeit';
				case 'ready': return 'freigegeben';
				case 'submitted': return 'übermittelt';
				case 'error': return 'FEHLER';
				default: return '';
			}
		},
		
		submitImportData: function () {
			var vm = this, rid = vm.selected_id
			vm.apiCall([{method: 'import/submit/enter', param: {import_id: rid}, id: 30},{method: 'import/list', param: {client_id: vm.client_id}, if: [{id: 30, path: 'result/success', eq: true}], id: 10}], vm.evalApiResponse)
			this.$modal.hide('modalSubmit')
		},
		
		populateDT: function () {
			var vm = this, r = [], f = this.filter, filter = {};
			
			if (f.date.mode !== '') {
				if (this.valid_start_date) filter['start_date'] = this.$moment(f.date.start, 'DD.MM.YYYY').format('YYYY-MM-DD');
				if (this.valid_end_date) filter['end_date'] = this.$moment(f.date.end, 'DD.MM.YYYY').format('YYYY-MM-DD');
			}
			if (f.type !== '') filter['type'] = f.type;
			if (f.status !== '') filter['status'] = f.status;
			if (f.text !== '') filter['text'] = f.text;
			
			if (vm.$store.state.customer.accounting_tool === 'pesaris 2') r.push({method: 'client/param/reftype/list', param: {client_id: vm.client_id}, id: 40});
			r.push({method: 'arap/document/list', param: {client_id: vm.client_id, mode:'transfer', filter: filter}, id: 10});
			vm.apiCall(r, vm.evalApiResponse);
		},
		
		evalApiResponse: function (resp) {
			var vm = this, o, i, n;
			this.$_.forEach(resp, function (value) {
			  if (value.hasOwnProperty('id')) {
				switch (value.id) {
				  case 10: // 10 = Result from 'import/list'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						o = value.result;
						n = o.length;
						for (i=0; i<n; i++) o[i]['selected'] = false;
						vm.recs = o;
					}
					break
				  case 30: // 30 = Result from 'import/submit/enter'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						if (value.result.hasOwnProperty('incomplete')) vm.$snotify.error('Die Daten wurden übermittelt. Siehe Buchungsprotokoll für Details.', 'ERROR', {timeout: 8000})
						else vm.$snotify.success('Die Daten wurden verbucht', 'OK')
					}
					break
				  case 40: // 40 = Result from 'client/param/reftype/list'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
			//						console.log(value)
						vm.reftypes = value.result
					}
					break
				}
			  }
			})
		}
    },
    filters: {
		recdate: function (val) {
			var a = val.substr(0,10).split('-')
			return a[2] + '.' + a[1] + '.' + a[0]
		},
		recstatus: function (val) {
			switch(val) {
				case 'PENDING': return 'AUSSTEHEND'
				case 'DOWNLOADED': return 'HERUNTERGELADEN'
				case 'SUBMITTED': return 'ÜBERMITTELT'
				default: return ''
			}
		}
    },
    watch: {
		client_id (newVal, oldVal) {
			this.populateDT();
		}
    },
    mounted: function () {
		this.populateDT();
    }
  }
</script>

<style scoped="">
button {
	border: 1px solid #000;
	background: #888;
	color: #fff;
	margin-bottom: 20px;
	margin-right: 5px;
	padding: 5px 10px;
	cursor: pointer;
	font-weight: 700;
}

button:hover {
	background: #666;
}

table {
	border-collapse: collapse;
	border: 1px solid #888;
	margin-bottom: 20px;
}

th {
	background: #317dff;
	color: #fff;
	padding: 10px 10px;
	min-width: 30px;
	text-align: left;
	border-bottom: 1px solid #888;
}

td {
	color: #333;
	padding: 10px 10px;
	text-align: left;
}

tr:nth-child(even) {background: #eee}
tr:nth-child(odd) {background: #fff}

tr.approved {background: #a9ffa9}

td > i {
	cursor: pointer;
}

input[type=text], select {
	border: 1px solid #888;
	padding:3px;
	background: #fff;
}

.badge {
	border-radius: 5px;
	padding: 3px 5px;
	color: #fff;
}

.badge.ar {
	background: #1E90FF;
}

.badge.ap {
	background: #AF04AF;
}

.badge.pending {
	background: #888;
}

.badge.ready {
	background: #FFA500;
}

.badge.submitted {
	background: #008000;
}

.badge.error {
	background: #f00;
}


/* CONFIRM DELETION*/
.delConf-title {
	cursor: move;
	font-weight: 700;
	line-height: 40px;
	border-bottom: 1px solid #aaa;
	padding: 0 10px;
}

.delConf-content {
	padding: 20px 10px;
}

.delConf-button-wrapper {
	border-top: 1px solid #aaa;
	padding: 10px 10px 0 10px;
}

.delConf-button-wrapper button {
	margin-left: 5px;
}

.delConf-btn-del {
	background: #c00;
}

.delConf-btn-del:hover {
	background: #a00;
}

.disabled {
	cursor: auto;
	color: #aaa;
}

.anl {
	text-decoration: none;
	color: #000;
}


.filterwrp {
	display: inline-flex;
	flex-direction: column;
	background: #fff;
	border: 1px solid #888;
	margin-bottom: 10px;
	margin-right: 10px;
}

.filterwrp > div {
	padding: 5px;
}

.filterwrp > div:first-child {
	color: #eee;
	background: #888;
	font-weight: bold;
}
.filterwrp > div:first-child > i {
	margin-right: 5px;
}

.filterwrp .dateflds > input[type=text] {
	width: 85px;
}

.date_err {
	background: #fcc!important;
}

.dnldbtn:disabled {
	opacity: 0.33;
	cursor: inherit;
}

.stxt {
	width: 100px;
}

.fas.rmargin, .far.rmargin {
	margin-right:5px;
}

.reftype label {
	margin-right: 20px;
}
</style>
